
import { getTrustLevel } from "context/context";
import Agents from "../Agents";
import AreaContainer from "../AreaContainer";
import logInternalLinkClick from "lib/ga/internalLinkClick";
import styles from './sidebar.module.css';
import globalStyles from '../result.module.css';

type Props = {
  active: Active,
  parent: Parent,
  sponsored: boolean,
  isLoggedIn: boolean,
  payingClient: boolean,
  contactable: boolean,
  showAllAgentContacts: boolean,
  showPage: boolean
}

type Active = {
  id: number,
  docType: string,
  activePortfolio: {
    id: number,
    uri: string,
    sponsored: number,
    active: boolean,
    advertise: boolean,
    name: string,
  },
  sponsored: boolean;
  isLDC: boolean;
  owners: any;
  agents: any;
  centre_managers: any;
  asset_managers: any;
  name: string;
  local_agents: any;
  title: string;
  isLoggedIn: boolean;
  unfilteredAgents: any;
  payingClient: boolean;
  contactable: boolean;
  bid: boolean
  showPage: boolean;
  setShowAllAgentContacts: any;
  property: object;
  dxStats: number;
}

type Parent = {
  url: string,
  name: string
}

const Sidebar = ({ active, property, parent, sponsored, dxStats, isLoggedIn, payingClient, contactable, showAllAgentContacts, showPage }: Props) => {
  let { id, activePortfolio } = active;
  const trust = getTrustLevel();
  return (
    <AreaContainer area="sidebar" style={{ marginBottom: '1rem' }} extraClass={styles.topMarging}>
      <Agents isLoggedIn={isLoggedIn} property={property} dxStats={dxStats} showAllAgentContacts={showAllAgentContacts}  {...active} sponsored={sponsored} isLoggedIn={isLoggedIn} payingClient={payingClient} contactable={contactable} showPage={showPage} />
{/*
      {parent?.url && <a className={styles.ButtonContainer} href={`/scheme/${parent.url}`}>

        <div className={`${styles.smallButton} ${globalStyles.largeText}`} onClick={(e) => logInternalLinkClick("Property Page parent scheme button", `/scheme/${parent.url}`, id)}>
          {`View ${parent.name}`}
        </div>

      </a>}

      {activePortfolio?.id && activePortfolio?.uri && activePortfolio?.sponsored == 1 && activePortfolio?.active && activePortfolio?.advertise && <a className={styles.ButtonContainer} href={`/portfolio/${activePortfolio.uri}`}>

        <div className={`${styles.smallButton} ${globalStyles.largeText}`} onClick={(e) => logInternalLinkClick("Property Page portfolio button", activePortfolio.uri, id)}>
          {`${activePortfolio.name}'s Portfolio`}
        </div>

      </a>}

      {active.docType === "property" && trust >= 80 && (
        <a className={styles.ButtonContainer} href={`${process.env.NEXT_PUBLIC_PROPERTY_MANAGER}/property/${id}`}
          target="_blank"
          rel="noreferrer noopener"
          title="Edit in Property Manager">

          <div className={`${styles.smallButton} ${globalStyles.largeText}`} onClick={(e) => logInternalLinkClick("Edit in property manager button", `${process.env.NEXT_PUBLIC_PROPERTY_MANAGER}/property/${id}`, id)}>
            Edit in Property Manager
          </div>

        </a>
      )}
      {active.docType === "property" && trust >= 90 && (
        <a className={styles.ButtonContainer} href={`${process.env.NEXT_PUBLIC_ADMIN_URL}properties/property/${id}`}
          target="_blank"
          rel="noreferrer noopener"
          title="View in Admin">

          <div className={`${styles.smallButton} ${globalStyles.largeText}`} onClick={(e) => logInternalLinkClick("View in admin button", `${process.env.NEXT_PUBLIC_ADMIN_URL}/properties/property/${id}`, id)}>
            View in Admin
          </div>
        </a>
      )}
      {active.docType === "scheme" && trust >= 90 && (
        <a className={styles.ButtonContainer} href={`${process.env.NEXT_PUBLIC_ADMIN_URL}schemes/scheme/${id}`}
          target="_blank"
          rel="noreferrer noopener"
          title="View in Admin">

          <div className={`${styles.smallButton} ${globalStyles.largeText}`} onClick={(e) => logInternalLinkClick("View in admin button", `${process.env.NEXT_PUBLIC_ADMIN_URL}/properties/property/${id}`, id)}>
            View in Admin
          </div>
        </a>
      )}
        */}
    </AreaContainer>

  );
};
export default Sidebar;

